module.exports = __webpack_public_path__ + "video/SAF-300_Ares_WhatsInItForYou_2025.fcf9ca7e.vtt";